import React from "react";
import { Truck, ShieldCheck, BadgeCheck } from "lucide-react";
import { useSettings } from "../../context/SettingsContext";

export const TrustBadges = ({ className = "" }) => {
  const { settings } = useSettings();
  const mobile = (settings?.payment_methods || []).filter((m) => m.enabled && m.id !== "livraison").map((m) => m.label);
  const items = [
    { icon: Truck, text: "Livraison gratuite à Abidjan", id: "delivery" },
    { icon: ShieldCheck, text: `Paiement sécurisé ${mobile.length ? mobile.join(" / ") : "Mobile Money"}`, id: "payment" },
    { icon: BadgeCheck, text: "Pièce vérifiée par Yoyo", id: "verified" },
  ];
  return (
    <ul className={`space-y-2 ${className}`} data-testid="trust-badges">
      {items.map(({ icon: Icon, text, id }) => (
        <li key={id} data-testid={`trust-${id}`} className="flex items-center gap-2 text-sm text-[#6E544A]">
          <Icon className="h-4 w-4 shrink-0 text-[#D76E4D]" />
          <span>{text}</span>
        </li>
      ))}
    </ul>
  );
};
